import { makeAutoObservable } from "mobx";
import { io } from "socket.io-client";

const WS_URL = process.env.REACT_APP_WS_API_URL || "//localhost:5050";

export default class SocketStore {
  constructor() {
    this.socketRef = { current: null };
    makeAutoObservable(this, {}, { autoBind: true });
  }

  connect(token) {
    if (!token) return null;
    if (this.socketRef.current) return this.socketRef.current;

    const socket = io(WS_URL, {
      auth: { token },
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      timeout: 10000,
    });

    socket.on("connect", () => {
      console.log("Socket connected:", socket.id);
    });

    socket.on("connect_error", (error) => {
      console.error("Socket connection error:", error);
    });

    socket.on("disconnect", (reason) => {
      console.log("Socket disconnected:", reason);
    });

    this.socketRef.current = socket;
    return socket;
  }

  disconnect() {
    if (!this.socketRef.current) return;
    this.socketRef.current.disconnect();
    this.socketRef.current = null;
  }

  on(eventName, handler) {
    this.socketRef.current?.on(eventName, handler);
  }

  off(eventName, handler) {
    if (!this.socketRef.current) return;
    if (handler) {
      this.socketRef.current.off(eventName, handler);
      return;
    }
    this.socketRef.current.off(eventName);
  }
}
